import React from "react";
import _ from "lodash";
import PlaceholderBackground from "../utils/PlaceholderBackground.jsx";
import { Map } from "immutable"

import CrossDomainFrame from "./CrossDomainFrame";

const placeholderIcon = (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    style={{ width: "100%", height: "100%" }}
  >
    <g fill="#fff">
      <path
        d="M17,18c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l4.2-4.3l-4.2-4.3c-0.4-0.4-0.4-1,0-1.4
                                                          c0.4-0.4,1-0.4,1.4,0l4.9,5c0.4,0.4,0.4,1,0,1.4l-4.9,5C17.5,17.9,17.3,18,17,18z"
      />
      <path
        d="M7,18c-0.3,0-0.5-0.1-0.7-0.3l-5-5c-0.4-0.4-0.4-1,0-1.4l5-5c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L3.4,12
                                                             l4.3,4.3c0.4,0.4,0.4,1,0,1.4C7.5,17.9,7.3,18,7,18z"
      />
      <path
        d="M10,21c-0.1,0-0.2,0-0.2,0c-0.5-0.1-0.9-0.7-0.7-1.2l4-16c0.1-0.5,0.7-0.9,1.2-0.7c0.5,0.1,0.9,0.7,0.7,1.2
                                                              l-4,16C10.9,20.7,10.4,21,10,21z"
      />
    </g>
  </svg>
);

const PlaceHolder = () => {
  const placeholderInstrux = (
    <span>Enter iframe URL or embed code in properties panel&nbsp;&#8594;</span>
  );
  return (
    <div>
      <PlaceholderBackground icon={placeholderIcon} instrux={placeholderInstrux} />
    </div>
  );
};

const IFrame = ({ content = Map(), elemProps }) => {
  const iframeURL = content.get("url", false);
  const code = content.get("code", false);

  let iFrame;

  if (iframeURL) {
    iFrame = <CrossDomainFrame src={iframeURL} />;
  } else if (code) {
    const scale = elemProps.getIn(["if", "s"], 100) / 100;
    const scaleHeight = (1 / scale) * elemProps.get("h");
    const scaleWidth = (1 / scale) * elemProps.get("w");

    iFrame = (
      <div
        style={{
          transform: `scale(${scale},${scale})`,
          transformOrigin: "left top 0",
          width: scaleWidth,
          height: scaleHeight,
        }}
      >
        <CrossDomainFrame code={code} width={scaleWidth} height={scaleHeight} />
      </div>
    );
  } else {
    iFrame = <PlaceHolder />;
  }

  return iFrame;
};

export default IFrame;
